export default {
  // 树形递归数组reduce扁平化
  toLine(data, childrenField) {
    return data.reduce((arr, current) => arr.concat([current], this.toLine(current[childrenField] || [], childrenField)), [])
  }
}
